import { Button } from "@progress/kendo-react-buttons";
import { ComponentMode, GetParentNode } from "../../../../common/RichTextEditorTools";
import { CreateComponentHtml, GetObjectFromHtml } from "../common/utilities";
import { createPortal } from "react-dom";
import { LearningObjectiveReferenceComponentDialog } from "./learningObjectiveReferenceComponentDialog";
import { getLearningObjectives } from "../../../../common/classifications/helperFunctions";

export const learningObjectiveReferenceClassName = "learningobjectivereference";

let learningObjectives: any[];

export class LearningObjectiveReferenceComponent {
  data?: string;

  constructor(value?: string) {
    this.data = value;
  }
}

// Create component
export const GetLearningObjectiveReferenceComponentFromHTML = (html: string): LearningObjectiveReferenceComponent => {
  const object = GetObjectFromHtml(html);
  return object.data ? new LearningObjectiveReferenceComponent(object.data) : new LearningObjectiveReferenceComponent();
};

export const GetHtmlFromLearningObjectiveReferenceComponent = async (
  item: LearningObjectiveReferenceComponent
): Promise<string> => {
  if (learningObjectives === undefined) learningObjectives = await getLearningObjectives();

  const data =
    "<p>[Lärandemålsreferens]</p>" +
      item.data
        ?.split("|")
        .map((identifier) => {
          const lo = learningObjectives.find((lo: any) => lo.identifier === identifier);
          return `<p>${lo ? `${lo.name} [${lo.levelId} ${lo.typeId}]` : "Okänt lärandemål"}</p>`;
        })
        .join("") || "";

  return CreateComponentHtml(learningObjectiveReferenceClassName, item, data);
};

// Tool Button
export const EditNodeToolLearningObjectiveReferenceComponent = (settings: any) => (props: any) => {
  const { view } = props;
  const mode = ComponentMode(view, learningObjectiveReferenceClassName);

  const handleSubmitEditLearningObjectiveReferenceComponent = (props: any) => {
    const { newNode, nodeAndPos } = props;
    const state = view!.state;
    const tr = state.tr.replaceWith(nodeAndPos.pos, nodeAndPos.pos + nodeAndPos.node.nodeSize, newNode);
    view!.dispatch(tr);
    settings.setEditLearningObjectiveReferenceComponent(null);
  };
  const handleCancelEditLearningObjectiveReferenceComponent = () => {
    settings.setEditLearningObjectiveReferenceComponent(null);
  };

  return (
    <>
      <Button
        onClick={() => {
          const state = view.state;
          const tr = state.tr;
          const nodeAndPos = GetParentNode(
            tr.doc,
            tr.selection.from,
            tr.selection.to,
            "str-component-" + learningObjectiveReferenceClassName,
            false
          );
          if (nodeAndPos) {
            settings.setEditLearningObjectiveReferenceComponent({ nodeAndPos });
          }
        }}
        togglable={true}
        onMouseDown={(e) => e.preventDefault()}
        onPointerDown={(e) => e.preventDefault()}
        title={mode === 1 ? "Ändra lärandemålsreferens" : "Infoga lärandemålsreferens"}
        icon="star"
        selected={mode === 1}
        disabled={mode === -1}
      />
      {settings.editLearningObjectiveReferenceComponent &&
        createPortal(
          <LearningObjectiveReferenceComponentDialog
            {...settings.editLearningObjectiveReferenceComponent}
            editorSchema={view.state.schema}
            onSubmit={handleSubmitEditLearningObjectiveReferenceComponent}
            onCancel={handleCancelEditLearningObjectiveReferenceComponent}
            learningObjectives={settings.learningObjectives}
            learningObjectivesInLearningObject={settings.learningObjectivesInLearningObject}
            learningObjectUuid={settings.learningObjectUuid}
          />,
          document.body
        )}
    </>
  );
};
